// Componente para exibir tela de carregamento
import { useI18n } from '@/contexts/i18n-hook';

interface LoadingScreenProps {
  mensagem?: string;
}

export function LoadingScreen({ mensagem }: LoadingScreenProps) {
  const { t } = useI18n();

  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-sm text-gray-500">{mensagem ?? t('comum.estado.carregando')}</p>
      </div>
    </div>
  );
}
